import noahImage from '../images/NoahGambee.png';
import shannonImage from '../images/ShannonHicks.png';
import hannahImage from '../images/HannahBrantley.jpeg';
import billImage from '../images/BillFurgason.png';
import jasonImage from '../images/JasonMaye.png';
import michaelImage from '../images/MichaelGrosvenor.jpeg';
import owenImage from '../images/owenhallgren.png';
import mickeyImage from '../images/MickeyMallot.png';

function Team() {
  const leadership = [
    { name: 'Noah Gambee', title: 'President', image: noahImage },
  ];

  const teamMembers = [
    { name: 'Shannon Hicks', title: 'Lead Developer', image: shannonImage },
    { name: 'Hannah Brantley', title: 'Client Services', image: hannahImage },
    { name: 'Bill Furgason', title: 'Business Development', image: billImage },
    { name: 'Jason Maye', title: 'Project Manager', image: jasonImage },
    { name: 'Michael Grosvenor', title: 'Account Support', image: michaelImage },
    { name: 'Owen Hallgren', title: 'Software Developer', image: owenImage },
    { name: 'Mickey Mallot', title: 'Software Developer', image: mickeyImage },
  ];

  const renderMember = (member, index) => (
    <div key={`${member.name}-${index}`} className="team-member">
      <div className="team-member-image-container">
        <img
          src={member.image}
          alt={member.name}
          className="team-member-image"
        />
      </div>
      <h3 className="team-member-name">{member.name}</h3>
      <p className="team-member-title">{member.title}</p>
    </div>
  );

  return (
    <section id="team" className="team">
      <div className="container">
        <h2 className="section-title">Meet Our Team</h2>
        <p className="team-intro">
          Our experienced team brings decades of combined expertise in event marketing, 
          technology, and client service to deliver exceptional results.
        </p>
        
        <div className="team-leadership">
          {leadership.map((member, index) => renderMember(member, index))}
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => renderMember(member, index))}
        </div>
      </div>
    </section>
  );
}

export default Team;

